import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const disbursementRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/disbursement',
  component: lazyRouteComponent(() => import('@/pages/disbursement/disbursement-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});

export const detailDisbursementRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/disbursement/$id',
  component: lazyRouteComponent(() => import('@/pages/disbursement/detail-disbursement-page')),
});

export const detailBatchDisbursementRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/disbursement/batch/$id',
  component: lazyRouteComponent(
    () => import('@/pages/disbursement/detail-batch-disbursement-page'),
  ),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});
